import React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  search: string
  disabled: boolean
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}
const TableOptions = (props: Props) => {
  return (
    <Box width="full" paddingLeft="s8">
      <SearchField variant="big" autofocus placeholder={i18n.t('common.search')} {...props} />
    </Box>
  )
}

export default TableOptions
